import { code128 } from '@bwip-js/browser'

import type { TicketElement } from '../TicketElement'

export class Barcode implements TicketElement {
  code: string
  barcodeHeight: number
  paddingTop: number

  constructor(code: string) {
    this.code = code
    this.barcodeHeight = 80
    this.paddingTop = 25
  }

  height(): number {
    return this.barcodeHeight + this.paddingTop
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.paddingTop
    const canvas = document.createElement('canvas')
    code128(canvas, {
      bcid: 'code128',
      text: this.code,
      scaleX: 1,
      scaleY: 1,
      width,
      height: this.barcodeHeight
    })
    ctx.drawImage(canvas, 0, top, width, this.barcodeHeight)
  }
}
